export const EVENT_LOCATION_TYPE = {
  // TRANSLATORS: event listing location type
  ONSITE: getText('In Person'),
  // TRANSLATORS: event listing location type
  HYBRID: getText('Hybrid'),
  // TRANSLATORS: event listing location type
  REMOTE: getText('Virtual'),
};
